<ng-template #modal let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title"> {{isNewTask ? 'Nova Tarefa' : 'Editar Tarefa'}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group row">
      <div class="col-12">
        <ng-select [items]="taskTypes" [selectOnTab]="true" placeholder="Tipo de Tarefa" bindLabel="name"
          [formControl]="formTaskType" class="customSelect" [searchable]="false" [clearable]="false"
          appearance="outline" required>
          <ng-template ng-option-tmp ng-label-tmp let-item="item">
            {{item.name | translate}}
          </ng-template>
        </ng-select>
        <mat-error *ngIf="formTaskType.invalid">Campo obrigatório</mat-error>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-label>Executar à cada {{waitingHours}} {{waitingHours === 1 ? 'hora' : 'horas'}}</mat-label>
        <mat-slider min="1" max="24" step="1" value="1" [thumbLabel]="true" color="primary" [displayWith]="formatLabel"
          [(ngModel)]="waitingHours">
        </mat-slider>
      </div>
    </div>

    <div class="form-group row" *ngIf="!isNewTask">
      <label class="col-12 col-form-label">Status da Tarefa</label>
      <div class="col-lg-12">
        <div class="form-text text-muted">
          {{formStatusTask.value ? 'Ativo' : 'Inativo'}}
        </div>
        <span class="switch switch-icon">
          <label>
            <input type="checkbox" [formControl]="formStatusTask" />
            <span></span>
          </label>
        </span>
      </div>
    </div>

    <div class="form-group row" *ngIf="isNewTask">
      <label class="col-12 col-form-label">Hora da primeira execução</label>
      <div class="col-lg-12">
        <ngb-timepicker [formControl]="formStartTime" [minuteStep]="0" [spinners]="false"></ngb-timepicker>
      </div>
      <mat-error *ngIf="formStartTime.invalid">Campo obrigatório</mat-error>
    </div>


  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="save()"
      [disabled]="formTaskType.invalid || formStartTime.invalid">Salvar</button>
  </div>

</ng-template>
